import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

import { convertirFechaISO } from '../../../utils/utils';
import { AuthService } from '../../../services/auth.service';
import { SolicitudesService } from '../../../services/solicitudes.service';
import { SocketService } from '../../../services/socket.service';
import { FormHoraComponent } from '../../layout/form-hora/form-hora.component';
import { FormFechaComponent } from '../../layout/form-fecha/form-fecha.component';
import {
  getColor,
  getIncialesMayuscula,
  adjustPageSize,
} from '../../../utils/utils';

@Component({
  selector: 'app-bandeja',
  templateUrl: './bandeja.component.html',
  styleUrl: './bandeja.component.scss',
})
export class BandejaComponent implements OnInit, OnDestroy {
  _idRegistro: any;

  solicitudes: any = [];
  solicitudesOriginal: any[] = [];
  textoBusqueda: string = '';
  tipoFiltro: string = 'TODOS';
  tiposFiltro: string[] = ['TODOS'];
  estadoFiltro: string = 'TODOS';
  estadosFiltro: string[] = [
  'TODOS',
  'PENDIENTE',
  'APROBADO',
  'DENEGADO',
];

  displayedColumns: string[] = [
    'id',
    'nombre',
    'contrato',
    'solicitud',
    'fecha',
    'estado',
  ];

  cargo: string = '';
  nombre: string = '';
  contrato: string = '';
  datosGenerales: any = {};
  dataSource = new MatTableDataSource<any>([]);

  private solicitudUpdateToApproverSubscription: any = Subscription;

  private categorias: any[] = ['HORA', 'FECHA', 'RANGO', 'CALENDARIO'];

  id_cargo_aprobador: any;

  @Input() public data: any;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private solicitudService: SolicitudesService,
    private authService: AuthService,
    private socketService: SocketService,
    private cdr: ChangeDetectorRef,
  ) {
    this._idRegistro = this.authService.getUserRegistro().toString();
    this.id_cargo_aprobador = this.authService.getIsAprobador().toString();
  }

  ngAfterViewInit(): void {
    this.visualizacionDatasource();
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.load();

    this.solicitudUpdateToApproverSubscription =
      this.socketService.solicitudUpdateToApprover$.subscribe(
        (updatedSolicitud) => {
          if (!updatedSolicitud) return;

          const index = this.solicitudesOriginal.findIndex(
            (s: any) => s._id === updatedSolicitud._id,
          );

          if (index !== -1) {
            this.solicitudesOriginal[index] = updatedSolicitud;
          } else {
            this.solicitudesOriginal.unshift(updatedSolicitud);
          }
          this.cargarTiposFiltro();
          this.aplicarFiltroEstado();
        },
      );
  }

  ngOnDestroy(): void {
    if (this.solicitudUpdateToApproverSubscription) {
      this.solicitudUpdateToApproverSubscription.unsubscribe();
    }
  }

  async load() {
    try {
      this.solicitudes =
        (await this.solicitudService
          .getFiltroElementos(
            'id_cargo_aprobador',
            this.id_cargo_aprobador,
            'bandeja',
          )
          .toPromise()) || [];
    } catch (err) {}

    this.solicitudesOriginal = [...this.solicitudes];
    this.cargarTiposFiltro();

    this.dataSource = new MatTableDataSource(this.solicitudes);
    this.dataSource.paginator = this.paginator;

    this.aplicarFiltroEstado();
  }

  aplicarFiltroEstado() {
  let solicitudesFiltradas = [...this.solicitudesOriginal];

  if (this.estadoFiltro === 'DENEGADO') {
    solicitudesFiltradas = solicitudesFiltradas.filter(
      (s: any) => s.estado === 'DENEGADO' || s.estado === 'RECHAZADO',
    );
  } else if (this.estadoFiltro !== 'TODOS') {
    solicitudesFiltradas = solicitudesFiltradas.filter(
      (s: any) => s.estado === this.estadoFiltro,
    );
  }

  if (this.tipoFiltro !== 'TODOS') {
    solicitudesFiltradas = solicitudesFiltradas.filter(
      (s: any) =>
        this.normalizarTexto(s?.id_contenido?.titulo) ===
        this.normalizarTexto(this.tipoFiltro),
    );
  }

  const texto = this.normalizarTexto(this.textoBusqueda);

  if (texto) {
    solicitudesFiltradas = solicitudesFiltradas.filter((s: any) =>
      this.coincideConBusqueda(s, texto),
    );
  }

  this.solicitudes = [...solicitudesFiltradas];
  this.dataSource.data = [...this.solicitudes];

  if (this.dataSource.paginator) {
    this.dataSource.paginator.firstPage();
  }
}

//
cargarTiposFiltro() {
  const tipos = this.solicitudesOriginal
    .map((s: any) => s?.id_contenido?.titulo)
    .filter((tipo: any) => tipo);

  const tiposUnicos = Array.from(new Set(tipos)).sort((a: any, b: any) =>
    a.localeCompare(b),
  );

  this.tiposFiltro = ['TODOS', ...tiposUnicos];

  if (this.tipoFiltro !== 'TODOS' && !this.tiposFiltro.includes(this.tipoFiltro)) {
    this.tipoFiltro = 'TODOS';
  }
}

normalizarTexto(valor: any): string {
  return (valor ?? '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

coincideConBusqueda(solicitud: any, texto: string): boolean {
  const funcionario = solicitud?.id_registro?.id_funcionario || {};
  const cargo = solicitud?.id_registro?.id_cargo || {};
  const contenido = solicitud?.id_contenido || {};

  const camposBusqueda = [
    funcionario.nombre,
    funcionario.paterno,
    funcionario.materno,
    funcionario.casada,
    funcionario.ci,
    cargo.nombre,
    cargo.contrato,
    contenido.titulo,
    contenido.nombre,
    contenido.categoria,
    solicitud.estado,
    solicitud.detalle,
    solicitud.observacion,
    solicitud.fecha_envio,
  ]
    .map((campo) => this.normalizarTexto(campo))
    .join(' ');

  return camposBusqueda.includes(texto);
}
//
  fechaConvert(element: any) {
    return convertirFechaISO(element);
  }

  categoriaFecha(element: any) {
    console.log(element);
    const dialogRef = this.dialog.open(FormFechaComponent, {
      data: element,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.load();
      }
    });
  }

  categoriaHora(element: any) {
    const dialogRef = this.dialog.open(FormHoraComponent, {
      data: element,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.load();
      }
    });
  }
private esPermisoConGoce(element: any): boolean {
  return (
    String(element?.id_contenido?.denominacion || '')
      .trim()
      .toUpperCase() === 'CG'
  );
}
  editarSolicitud(element: any, status: boolean) {
  console.log('editarSolicitud: ', element);

  element.editar = true;
  element.esAprobador = true;
  element.esDetalle = true;
  element.esVista = true;
  element.estadoAprobador = 'PENDIENTE';
  element._idRegistroAprobador = this._idRegistro;

  // PERMISO CON GOCE DE HABER:
  // aunque en MongoDB sea FECHA, debe abrir FormHoraComponent.
  if (this.esPermisoConGoce(element)) {
    this.categoriaHora(element);
    return;
  }

  // Lógica original para los demás contenidos.
  const categoria = element?.id_contenido?.categoria || '';

  if (this.categorias.includes(categoria)) {
    switch (categoria) {
      case 'CALENDARIO':
        break;

      case 'RANGO':
        break;

      case 'FECHA':
        this.categoriaFecha(element);
        break;

      case 'HORA':
        this.categoriaHora(element);
        break;
    }
  }
}
    
abrirSolicitud(element: any) {
  const esSoloLectura =
    element.estado === 'APROBADO' ||
    element.estado === 'DENEGADO' ||
    element.estado === 'RECHAZADO';

  if (esSoloLectura) {
    element.editar = true;
    element.esAprobador = false;
    element.esDetalle = true;
    element.esVista = false;
  } else {
    element.editar = true;
    element.esAprobador = true;
    element.esDetalle = true;
    element.esVista = true;
    element.estadoAprobador = 'PENDIENTE';
    element._idRegistroAprobador = this._idRegistro;
  }

  // PERMISO CON GOCE DE HABER:
  // siempre debe utilizar FormHoraComponent.
  if (this.esPermisoConGoce(element)) {
    this.categoriaHora(element);
    return;
  }

  // Lógica original para los demás contenidos.
  const categoria = element?.id_contenido?.categoria || '';

  if (this.categorias.includes(categoria)) {
    switch (categoria) {
      case 'CALENDARIO':
        break;

      case 'RANGO':
        break;

      case 'FECHA':
        this.categoriaFecha(element);
        break;

      case 'HORA':
        this.categoriaHora(element);
        break;
    }
  }
}

  getColors(contrato: string): string {
    const color = getColor(contrato);
    return getColor(contrato);
  }

  capitalizeFirst(text: string): string {
    return getIncialesMayuscula(text);
  }

  private visualizacionDatasource() {
    adjustPageSize(this.paginator, this.dataSource);

    window.addEventListener('resize', () => {
      adjustPageSize(this.paginator, this.dataSource);
    });

    this.dataSource.paginator = this.paginator;
  }
}